import { useEffect, useRef } from 'react';

function useScrollReveal(options = {}) {
    const ref = useRef(null);

    useEffect(() => {
        const node = ref.current;
        if (!node) return;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('is-visible');
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.12, rootMargin: '0px 0px -8% 0px', ...options }
        );

        observer.observe(node);
        return () => observer.disconnect();
    }, [options]);

    return ref;
}

export default useScrollReveal;
